import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Slide, TextField } from "@mui/material";
import { forwardRef, useState } from "react";
import { orgDateUpdate } from "./edit_halper";
import { dateUsaToTimestamp, getCurrentDate, textDateToChrome } from "../frames/common";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function DateEdit({ data, open, handleClose, onSuccess }) {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setIsLoading(false);
        handleClose();
    }

    const handleSelfSubmit = (event) => {
        event.preventDefault();
        const frm_data = new FormData(event.currentTarget);
        const date_n = dateUsaToTimestamp(frm_data.get("date"));
        const flag = true;
        setIsLoading(true);
        if (flag) {
            const _json = { "cn": data.cn_no, "date": date_n };
            orgDateUpdate(_json).then((_) => {
                if (onSuccess) onSuccess({ "task": "date", "created": date_n, ..._json });
                handleSelfClose();
            }).catch(() => {
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    if (data === null || !open) return (<></>);

    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} keepMounted component="form" onSubmit={handleSelfSubmit}>
            <DialogTitle variant="h5" color="info">Date Correction - <small>{data.created}</small></DialogTitle>
            <DialogContent>
                <TextField variant="outlined" name="date" type="date" fullWidth error={inputErrors.date} defaultValue={textDateToChrome(data.created)} slotProps={{ htmlInput: { max: getCurrentDate(), min: "2024-04-01" } }} helperText={inputErrors.date} placeholder="Date" />
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="outlined" disabled={isLoading} onClick={handleSelfClose}>Cancel</Button>
                <Button variant="contained" disabled={isLoading} color="warning" type="submit">Save</Button>
            </DialogActions>
        </Dialog>
    );
}
export default DateEdit;
